import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';
import { workbookNameSortOption } from './ViewSortOptions';

export const dataAccelerationSortOptions: OptionsDictionary = {
  [OrderKeys.targetName]: createNonDisplayOptionDefinition(OrderKeys.targetName, OrderKeys.targetName),
  [OrderKeys.ownerName] : createNonDisplayOptionDefinition(OrderKeys.ownerName, OrderKeys.ownerName),
  [OrderKeys.containerName]: SortOptions.containerName,
  [OrderKeys.siteName]  : SortOptions.siteName,
  [OrderKeys.workbookName]: workbookNameSortOption,
  [OrderKeys.lastMonthJobCount]: createNonDisplayOptionDefinition(
                                    OrderKeys.lastMonthJobCount, OrderKeys.lastMonthJobCount),
  [OrderKeys.avgLoadTimeWithMaterialization]: createNonDisplayOptionDefinition(
                                    OrderKeys.avgLoadTimeWithMaterialization, OrderKeys.avgLoadTimeWithMaterialization),
  [OrderKeys.avgLoadTimeWithoutMaterialization]: createNonDisplayOptionDefinition(
                                    OrderKeys.avgLoadTimeWithoutMaterialization, OrderKeys.avgLoadTimeWithoutMaterialization),
  [OrderKeys.lastMonthViewCount]: createNonDisplayOptionDefinition(
                                    OrderKeys.lastMonthViewCount, OrderKeys.lastMonthViewCount),
  [OrderKeys.lastMonthJobAvgTimeInSec]: createNonDisplayOptionDefinition(
                                    OrderKeys.lastMonthJobAvgTimeInSec, OrderKeys.lastMonthJobAvgTimeInSec),
  [OrderKeys.estimatedDiskUsageKb]: createNonDisplayOptionDefinition(
                                    OrderKeys.estimatedDiskUsageKb, OrderKeys.estimatedDiskUsageKb),
};
